import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import auth0Config from "./servicos/auth0/Auth0Config";

import { BrowserRouter as Router } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container);

// Handle Auth0 redirect callback
const onRedirectCallback = (appState) => {
	// Store invitation token if present
	if (appState?.invitationToken) {
		sessionStorage.setItem("invitationToken", appState.invitationToken);

		// IMPORTANT: Trigger immediate processing
		// Don't wait for App.tsx to check later
		window.location.href = `/dashboard?process_invitation=${appState.invitationToken}`;
		return;
	}

	// Company claim (migration) flow: hard-redirect back to /claim so the page
	// remounts authenticated and resumes from the stored claim code.
	if (appState?.claimFlow) {
		window.location.href = "/claim";
		return;
	}

	// Normal redirect for non-invitation flows
	window.history.replaceState(
		{},
		document.title,
		appState?.returnTo || "/dashboard",
	);
};

root.render(
	<React.StrictMode>
		<Auth0Provider
			domain={auth0Config.domain}
			clientId={auth0Config.clientId}
			onRedirectCallback={onRedirectCallback}
			authorizationParams={{
				redirect_uri: auth0Config.redirectUri,
				audience: auth0Config.audience,
				scope: auth0Config.scope,
			}}
		>
			<Router basename={process.env.PUBLIC_URL}>
				<App />
			</Router>
		</Auth0Provider>
	</React.StrictMode>,
);
